import {
  Box,
  Button,
  Divider,
  Group,
  Modal,
  Stack,
  Text,
  Textarea,
  Title,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { X } from 'tabler-icons-react';
import { AcquirerTypes } from '../../../enums/acquirer-types.enum';
import { updateOnboardingStatus } from '../../../helpers/onboarding-status';
import {
  BasicMerchant,
  MerchantOnboardingStatusAction,
  RetrieveMerchantResponse,
  UpdateMerchantOnboardingStatusRequest,
} from '../../../type/admin.types';

interface Props {
  isDeclinedModalOpen: boolean;
  handleClose: () => void;
  entity: BasicMerchant | RetrieveMerchantResponse;
  updateTable: React.Dispatch<React.SetStateAction<boolean>>;
  acquirerColumn?: AcquirerTypes;
}

const DeclineMerchant = ({
  isDeclinedModalOpen,
  handleClose,
  updateTable,
  entity,
  acquirerColumn,
}: Props) => {
  const form = useForm({
    initialValues: {
      reason: '',
    },
    validate: {},
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async ({ reason }: { reason: string }) => {
    try {
      setIsLoading(true);

      const request: UpdateMerchantOnboardingStatusRequest = {
        merchantIds: [entity.merchantId],
        onboardingStatus: MerchantOnboardingStatusAction.DECLINE,
        declinedReason: reason,
      };

      await updateOnboardingStatus(request, acquirerColumn);
      form.setFieldValue('reason', '');
      updateTable((prev) => !prev);
      handleClose();
    } catch (err: any) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      size='xl'
      className='disable-modal'
      opened={isDeclinedModalOpen}
      onClose={() => {
        form.setFieldValue('reason', '');

        handleClose();
      }}
      centered
      closeOnClickOutside={isLoading ? false : true}
      closeOnEscape={isLoading ? false : true}
      data-cy='declineModal'
      withCloseButton={false}
    >
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack p='xl'>
          <Group>
            <Box
              sx={() => ({
                borderRadius: 8,
                backgroundColor: '#4F4F4F',
                color: '#fff',
                height: '3.81rem',
                width: '3.81rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              })}
            >
              <X />
            </Box>
            <Stack spacing='xs'>
              <Title>Decline Merchant</Title>
              <Text>
                Are you sure you want to decline {entity.merchantName}?
              </Text>
            </Stack>
          </Group>

          <Divider mt={4} mb={4} />

          <Textarea
            label='Enter Reason'
            value={form.values.reason}
            onChange={(e) => form.setFieldValue('reason', e.target.value)}
            minRows={4}
            maxRows={12}
            required
            autosize
            data-cy='reasonTextArea'
          />
          {/* <RichTextEditor
            value={form.values.reason}
            onChange={(value) => form.setFieldValue('reason', value)}
            data-cy='reasonTextArea'
            controls={[
              ['bold', 'italic', 'underline', 'strike'],
              ['h1', 'h2', 'h3', 'h4'],
              ['unorderedList', 'orderedList'],
            ]}
            placeholder='Enter Reason'
          /> */}

          <Group mt={8} grow>
            <Button
              variant='default'
              onClick={() => {
                form.setFieldValue('reason', '');

                handleClose();
              }}
              disabled={isLoading}
              data-cy='closeButton'
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: '#ff3232' }}
              type='submit'
              loading={isLoading}
              data-cy='submitButton'
            >
              Decline
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export default DeclineMerchant;
